require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/fn/object/set-prototype-of.js
// module id = 339
// module chunks = 7